import axios from 'axios';
import { settings } from '@/api/config';
import { getInitData } from '@/utils/getInitData';

export const getGameTasks = async () => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const response = await axios.get(
    `${settings.url}api/tasks/game-tasks/get?initData=${encodedInitData}`,
  );
  console.log('🎮 Game tasks:', response);
  return response.data;
};





